"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const types_1 = require("@air/types");
const querystring_1 = require("querystring");
const request_1 = require("./request");
/**
 * Gets members, boards and tags as suggestions for a workspace
 */
function getSuggestions(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, options, }) {
        const paramString = (0, querystring_1.stringify)(options);
        return (0, request_1.airRequest)(types_1.EndpointType.search, {
            endpoint: `suggestions?${paramString}`,
            workspaceId,
            boardContext: options.boardId,
        });
    });
}
/**
 * Get board context sensitive data for search filtering
 *
 * @param args
 * @param args.workspaceId - workspace context in which to get filters
 * @param args.boardId - board context in which to get filters
 */
function getFilterLookups(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.search, {
            endpoint: 'lookups',
            workspaceId,
            method: 'POST',
            body: {
                boardId,
            },
            boardContext: boardId,
        });
    });
}
/**
 * Get board context-sensitive data for search filtering
 *
 * @param args
 * @param args.workspaceId - workspace context in which to get filters
 * @param args.field - field to get filter lookups for
 * @param [args.libraryId] - library context in which to get filters
 * @param [args.boardId] - board context in which to get filters
 * @param [args.search] - search term to filter lookups by
 * @param [args.limit] - limit the number of lookups returned (default: 50, max: 100)
 * @param [rest.camera] - camera context to filter lookups by (e.g. only return models of a specific make)
 * @param [rest.location] - location context to filter lookups by (e.g. only return cities of a specific state & country)
 */
function getAssetVersionFilterLookups(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId, field, boardId } = _a, rest = __rest(_a, ["workspaceId", "field", "boardId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.search, {
            endpoint: `lookups/versions/${field}`,
            workspaceId,
            method: 'POST',
            body: Object.assign({ boardId }, rest),
            boardContext: boardId,
        });
    });
}
function getEntityLookups(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, options, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.search, {
            endpoint: `entityLookups`,
            workspaceId,
            method: 'POST',
            body: options,
        });
    });
}
exports.Search = {
    getSuggestions,
    getFilterLookups,
    getAssetVersionFilterLookups,
    getEntityLookups,
};
//# sourceMappingURL=search.js.map